<template>
   
    <div> 
        <div class="crumbs" hidden="true"  style="margin-left:10px;">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-calendar"></i> 产品管理
                </el-breadcrumb-item>
                <el-breadcrumb-item>落地页模板</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        
          <el-card shadow="hover"  class="searchCard" >
                <el-button  type="primary"  icon="el-icon-lx-roundadd" class="mr10"  @click="addBind" >新增落地页模板</el-button>  
          </el-card>
          <el-card shadow="hover"  class="containCard" >
            <el-table :data="tableData" border class="table"  ref="multipleTable" header-cell-class-name="table-header"  @selection-change="handleSelectionChange" 
            v-loading="loading"  element-loading-text="请稍等..." element-loading-spinner="el-icon-loading" >
                <!--<el-table-column type="selection" width="35" align="center"></el-table-column>
                <el-table-column prop="code" width="120" align="left" label="模板编码"></el-table-column>   -->   
                <el-table-column prop="name" min-width="160" align="left" label="模板名称"></el-table-column>     
                <el-table-column prop="fb1" min-width="160" align="left" label="模板说明"> </el-table-column>     
                <el-table-column prop="path" width="120" align="left" label="模板编码"> </el-table-column>     
                <el-table-column prop="descript" width="125" align="center" label="示例图">
                    <template slot-scope="scope" >   
                        <el-button  type="success" @click="getImgList(scope.$index, scope.row)" >查看</el-button>  
                    </template> 
                </el-table-column>      
                <el-table-column label="操作" min-width="160" align="center"  fixed="right">
                    <template slot-scope="scope"> 
                        <span class='tableOperBtn' @click="handleLink(scope.$index, scope.row)" ><i class='el-icon-link'></i> 产品链接</span>
                        <span class='tableOperBtn' @click="handDelete(scope.$index, scope.row)" ><i class='el-icon-delete'></i> 删除</span>
                        
                    </template>
                </el-table-column> 
            </el-table> 
        </el-card> 
        <!-- 新建自主渠道弹出框 --> 
        <el-dialog :close-on-click-modal="false" title="新增落地页模板" :visible.sync="addVisible" :modal-append-to-body='false' top="80px" width="530px">
            <el-form ref="form1" :model="form1" label-width="100px" @submit.native.prevent="saveForm">
                <el-form-item label="模板名称">
                    <el-input v-model.trim="form1.name"  placeholder="不超过10个字" style="width:360px;"></el-input>
                </el-form-item>  
                <el-form-item label="模板说明">
                    <el-input v-model.trim="form1.fb1"  placeholder="不超过10个字" style="width:360px;"></el-input>
                </el-form-item> 
                <el-form-item label="模板编码">
                    <el-input v-model.trim="form1.path"  placeholder="不超过10个字" style="width:360px;"></el-input>
                </el-form-item>
                <el-form-item label="落地页图片">
                    <el-upload action="#" list-type="picture-card" :file-list="fileList" :on-remove="handleRemove" :on-change="handleChange" multiple="true" :limit="3" :on-exceed="overMaxImg" :auto-upload="false" >
                        <i slot="default" class="el-icon-plus" tip="点击或拖动上传"></i>
                            <div slot="file" slot-scope="{file}">
                                <img class="el-upload-list__item-thumbnail" :src="file.url" alt=""  >
                                <span class="el-upload-list__item-actions"> 
                                    <span class="el-upload-list__item-preview"  @click="handlePictureCardPreview(file)">
                                        <i class="el-icon-zoom-in"></i>
                                    </span> 
                                    <span  v-if="!disabled"  class="el-upload-list__item-delete" @click="handleRemove(file)">
                                        <i class="el-icon-delete"></i>
                                    </span>
                                </span>
                            </div>
                        </el-upload> 
                        <el-dialog :modal-append-to-body='false' :modal="false" width="360px"  :visible.sync="dialogVisible">
                            <img style="width:300px" :src="dialogImageUrl" alt="">
                        </el-dialog>  
                </el-form-item>    
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveForm">{{ isSubmitting ? '提交中...' : '提 交' }}</el-button>
            </span>
        </el-dialog>
        
        <el-dialog :close-on-click-modal="false" title="产品链接"  :modal-append-to-body='false'  :visible.sync="linkVisible" top="30px" width="800px">
            <div >
                <span class="label-span">
                    <label class="label">资源名称</label> 
                    <el-select v-model="query2.channelCode"  placeholder="资源名称" filterable  clearable class="handle-select mr10">
                        <el-option value="" label="全部"  />  
                        <el-option v-for="item in select6.option" :key="item.id" :label="item.optVal" :value="item.optKey" /> 
                    </el-select>
                </span> 
                <span class="label-span">
                    <label class="label">产品名称</label> 
                    <el-input v-model.trim="query2.goodsName" placeholder="产品名称" style="width:180px;" class="handle-input mr10"></el-input> 
                </span>  
                <el-button type="success" icon="el-icon-search" class="mr10"   @click="handleSearch2">搜索</el-button>
                <el-button type="error" icon="el-icon-refresh" class="mr15"   @click="refreshSearch2">重置</el-button> 
            </div>
            <el-table    :data="tableData2"  class="table"  ref="multipleTable" header-cell-class-name="table-header"  
             v-loading="loading2"  element-loading-text="请稍等..." element-loading-spinner="el-icon-loading" >
                <el-table-column prop="createTime" width="90" align="left"  label="产品图片">
                     <template slot-scope="scope" > 
                        <img :src="scope.row.imgs.split(',')[0]" style="width:60px;height:60px;"  />   
                    </template>
                </el-table-column>  
                <el-table-column prop="channelName" width="120" align="left" label="资源名称"></el-table-column>
                <el-table-column prop="goodsName" min-width="200" align="left" label="产品名称">
                    <template slot-scope="scope" >
                        <el-link @click="copyLink('产品名称',scope.row.goodsName)" style="line-height:16px;color:#be9d1d;">{{scope.row.goodsName}}</el-link> 
                    </template>
                </el-table-column>   
                <el-table-column prop="goodsName" width="120" align="center" label="链接">
                    <template slot-scope="scope" >
                        <el-button @click="getLink(scope.row.goodsName+'-落地页链接',scope.row.goodsCode)" type="success" class="mr10" >复制链接</el-button>
                    </template>
                </el-table-column>   
            </el-table> 
            <div class="pagination">
                <el-pagination 
                    background
                    layout="total,  sizes,prev, pager, next,jumper"
                    :page-sizes="[5,10]"
                    :current-page="query2.pageIndex"
                    :page-size="query2.pageSize"
                    :total="pageTotal2"
                    @size-change="handleSizeChange2"
                    @current-change="handlePageChange2" 
                ></el-pagination>
            </div> 
        </el-dialog>
        <!-- 编辑自主渠道弹出框 --> 
        <el-dialog :close-on-click-modal="false" title="修改落地页模板" :visible.sync="editVisible" :modal-append-to-body='false' top="80px" width="530px">
            <el-form ref="form2" :model="form2" label-width="100px">
                <el-form-item label="模板名称">
                    <el-input v-model.trim="form2.name"  placeholder="不超过10个字" style="width:360px;"></el-input>
                </el-form-item>  
                <el-form-item label="模板说明">
                    <el-input v-model.trim="form2.fb1"  placeholder="不超过10个字" style="width:360px;"></el-input>
                </el-form-item> 
                <el-form-item label="模板编码">
                    <el-input v-model.trim="form2.path"  placeholder="不超过10个字" style="width:360px;"></el-input>
                </el-form-item>
                <el-form-item label="落地页图片">
                    <el-upload action="#" list-type="picture-card" :file-list="fileList" :on-remove="handleRemove" :on-change="handleChange" multiple="true" :limit="3" :on-exceed="overMaxImg" :auto-upload="false" >
                        <i slot="default" class="el-icon-plus" tip="点击或拖动上传"></i>
                            <div slot="file" slot-scope="{file}">
                                <img class="el-upload-list__item-thumbnail" :src="file.url" alt=""  >
                                <span class="el-upload-list__item-actions"> 
                                    <span class="el-upload-list__item-preview"  @click="handlePictureCardPreview(file)">
                                        <i class="el-icon-zoom-in"></i>
                                    </span> 
                                    <span  v-if="!disabled"  class="el-upload-list__item-delete" @click="handleRemove(file)">
                                        <i class="el-icon-delete"></i>
                                    </span>
                                </span>
                            </div>
                        </el-upload> 
                        <el-dialog :modal-append-to-body='false' :modal="false" width="360px"  :visible.sync="dialogVisible">
                            <img style="width:300px" :src="dialogImageUrl" alt="">
                        </el-dialog>  
                </el-form-item>    
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit">确 定</el-button>
            </span>
        </el-dialog>
`   `
        <el-dialog :close-on-click-modal="false" title="模板示例图" :visible.sync="imgVisible" :modal-append-to-body='false' top="80px" width="420px">
            <div style="max-height:500px;overflow-y:scroll;vertical-align:top;">
            <span style="float:left;" v-for="item in fileList">
                <img :src="item.url" style="width:360px;" />
            </span>
            </div>    
             
        </el-dialog>
          
    </div>
</template>

<script>
import {fetchData,saveForm,handDelete,changeForm,changeStatus,fetchDataDir,getFormartImg,getFilesDetail} from '../../api/h5template'; 
import {fetchSelect as fetchSelect6} from '../../view/channel/channel';  //渠道名称
import {fetchData as fetchData2} from '../../api/comGoods';  
export default {

    data() {
        return {  
            isSubmitting: false, // 是否正在提交
            Timeout:'', 
            activeNames:1,
            select:{ option:'',  },
            select6:{ option:'',  },
            sendSms:{
                code:'', 
                content:'发送验证码',
                type:'danger',
                disabled:false,
                color:'color:#fff',
             },
            
            query: { 
                pageIndex: 1,
                pageSize: 10,  
            },
            query2: { 
                pageIndex: 1,
                pageSize: 5,  
            },
            templateId:'',
            fileList:[],
            dialogImageUrl:'',
            dialogVisible:false,
            imgVisible:false,
            tableData: [],
            tableData2: [],
            multipleSelection: [],
            delList: [],
            editVisible: false,
            editPlusVisible: false,
            addVisible: false,
            addPlusVisible:false,
            detailVisible:false, 
            dirVisible:false,
            linkVisible:false,
            row:{},
            pageTotal: 0,
            pageTotal2: 0,
            form: {  
                ids:'',
                names:'',
            },
            form1: {
                ctype:'2',  
            },
            form2: {   },
            form3: {   },
            form4: {   },
            idx: -1,
            id: -1
        };
    },
    created() {
         
    },
    //页面加载方法
    mounted: function () { 
        //查询列表
        this.getData();  
    },

    methods: {  
        copyLink(name,text){  
            var copy = document.createElement("input");
            copy.setAttribute("value", text);
            document.body.appendChild(copy);
            copy.select();
            document.execCommand("copy");
            document.body.removeChild(copy);  
            //提示已复制
            this.$message.success(name+"复制成功");  
        },
        getLink(name,goodsCode){  
            var host = localStorage.getItem(window.location.hostname+'_stationUrl');
            var mid = localStorage.getItem(window.location.hostname+'_mid'); 
            var link = name+"： "+window.location.protocol+"//"+host+"/h5/cl/"+this.templateId+"_2/"+goodsCode;
            this.copyLink(name,link);
        },
        // 触发搜索按钮 
        handleSearch() {
            this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },

        //重置按钮
        refreshSearch(){ 
            this.$set(this.query, 'name', '');  
            this.$set(this.query, 'status');    
            this.getData();
        },
        // 触发搜索按钮 
        handleSearch2() {
            this.$set(this.query2, 'pageIndex', 1);
            this.getData2();
        },

        //重置按钮
        refreshSearch2(){ 
            this.$set(this.query2, 'goodsName', '');  
            this.$set(this.query2, 'channelCode');    
            this.getData2();
        },  
        //触发刷新按钮
        refresh(){
            history.go(0);
            
        }, 
        handleLink(index,row){
            this.templateId = row.path;
            //查询列表数据
            this.loading =true; 
            this.getSelect6();
            this.getData2();  
            setTimeout(() => {
                this.loading =false;
                this.linkVisible = true;
            }, 1000); 
        },
        getSelect6(){ 
            this.select6 = {};  
            fetchSelect6(this.select6).then(res => {   
                if(res.code=='200'){ 
                    this.$set(this.select6, 'option', res.data);  
                }
            });
        },

        //查询
        getData(){ 
            this.query.stationId = this.stationId;  
            this.query.mid = this.mid;
            this.query.secret = this.secret; 
            fetchData(this.query).then(res => {  
                if(res.code=='200'){ 
                    this.tableData = res.data.list;
                    this.pageTotal = res.data.pageTotal ;  
                }else{
                    this.tableData = []; 
                    this.pageTotal = 0;
                } 
                
            });
        },
        getData2(){
            // 获取列表数据    
            fetchData2(this.query2).then(res => {   
                if(res.code=='200'){ 
                    this.tableData2 = res.data.list;
                    this.pageTotal2 = res.data.pageTotal ;   
                }else{
                    this.tableData2 = []; 
                    this.pageTotal2 = 0; 
                } 
                
            });
        },
        //详情图上传成功追加数据 
        handleChange(file,fileList) {  
            const isJPG =file.raw.type === "image/png" || file.raw.type === "image/jpg" || file.raw.type === "image/jpeg";
            const isLt5M = file.size / 1024   < 1024;
            if (!isJPG) {
                this.$message.error("上传图片只能是 jpg、jpeg、png 格式!");
                fileList.splice(-1, 1);//移除错误文件
                return false;
            }
            if (!isLt5M) {
                this.$message.error("上传图片单张大小不能超过 1MB!");
                fileList.splice(-1, 1);
                return false;
            }  
            this.fileList = fileList;	  
            
        }, 
        //删除图片 
        handleRemove(file, fileList) {  
            let a = file.url ;
            let b = this.form1.detailPlain.indexOf(a);
            this.form1.detailPlain.splice(b,1);
            this.dialogImageUrl.splice(b,1); 
        }, 
        handleRemove(file) {   
            let i = this.fileList.indexOf(file);   
            this.fileList.splice(i,1); 
        }, 
         //详情图放大
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true; 
        }, 
        //文件上传超过最大数量提示
        overMaxImg(file,fileList){
            this.$message.error("图片最多只能上传3张"); 
        },

        // 新增渠道
        addBind() {
            this.addVisible = true; 
            this.fileList = [];
        },
        //保存新增
        saveForm() {   
            if (this.isSubmitting) return;
            this.isSubmitting = true; // 禁用按钮
            if( !this.form1.name ){
                this.isSubmitting = false;
                this.$message.error("请填写模板名称");
                return;
            }  
            if( !this.form1.path ){
                this.isSubmitting = false;
                this.$message.error("请填写模板编码");
                return;
            } 
            /*if( this.fileList.length<1 ){
                this.isSubmitting = false;
                this.$message.error("请上传图片");
                return;
            }     */
            this.loading = true;  
            this.loadingTitle = "正在保存...";
            
            let formData = new FormData();  
            formData.append("name",this.form1.name); 
            formData.append("path",this.form1.path);  
            formData.append("fb1",this.form1.fb1);  
            if(this.fileList.length>0){
                for(let j = 0; j < this.fileList.length; j++) {
                    formData.append("files", this.fileList[j].raw,this.fileList[j].name); 
                }  
            } 
            setTimeout( () => {
                 this.loading = false;  
                this.addVisible = false; 
                this.$message.info("正在添加，请稍后..."); 
                setTimeout( () => {   this.refreshSearch();  }, 5000) 
            }, 5000) 
            saveForm(formData).then(res => {
                this.loading = false;  
                this.isSubmitting = false;
                if(res.code='200'){
                    this.addVisible = false;
                    this.refreshSearch();
                    this.$message.success("添加成功"); 
                }else{
                    this.$message.error("添加异常"+res.message); 
                }
            });  
        },

        

        // 编辑操作
        handleEdit(index, row) {   
            //文件回显    
            this.fileList = [];
            let data = {};
            data.temCode = row.code;
            getFilesDetail(data).then(res => {
                if(res.code=='200'){  
                    this.fileList = res.data;   
                    this.form2 = row;
                    this.editVisible = true; 
                }else{ 
                    this.$message.error(res.message); 
                } 
            });      
        },
 
        
        // 保存更改
        saveEdit() {  
            if( !this.form2.name ){
                this.$message.error("请填写模板名称");
                return;
            }  
            if( !this.form2.path ){
                this.$message.error("请填写模板编码");
                return;
            } 
            if( this.fileList.length<1 ){
                this.$message.error("请上传图片");
                return;
            }      
            this.loading = true;  
            this.loadingTitle = "正在保存...";
            this.editVisible = false; 
            let formData = new FormData();  
            formData.append("name",this.form2.name); 
            formData.append("path",this.form2.path);  
            formData.append("id",this.form2.id);  
            formData.append("temCode",this.form2.code);  
            formData.append("fb1",this.form2.fb1);  
            var fileIds="";
            for(let j = 0; j < this.fileList.length; j++) {
                if(this.fileList[j].raw){ 
                    formData.append("files", this.fileList[j].raw,this.fileList[j].name); 
                }else{
                    fileIds+= +this.fileList[j].fileId+","; 
                } 
            } 
            if(fileIds.length>1){fileIds=fileIds.substr(0,fileIds.length-1)}
            formData.append("fileIds",fileIds);    
            setTimeout( () => {
                this.loading = false;  
                this.getData();
            }, 5000)
            changeForm(formData).then(res => {
                this.loading = false;  
                if(res.code=='200'){
                    this.editVisible = false; 
                    this.$message.success(res.message); 
                    this.getData();
                }else{
                    this.$message.error(res.message); 
                }
            });  
 
        },
        getImgList(index,row){
            //文件回显    
            this.fileList = [];
            let data = {}; 
            data.temCode = row.code;
            getFilesDetail(data).then(res => {
                if(res.code=='200'){  
                    this.fileList = res.data;   
                    this.imgVisible = true;    
                }else{ 
                    this.$message.error(res.message); 
                } 
            });     
        },
        // q启用、禁用--改变状态
        handleStatus(index, row) {  
            var tips ;
            var content;
            if(row.status=='0'){ 
                tips = "禁用";
                content = "确定禁用吗？";
            }else{ 
                tips = "启用";
                content = "确定启用吗？"; 
            }
            // 二次确认删除
            this.$confirm(content, '提示', {
                type: 'warning'
            }).then(() => { 
                changeStatus(row).then(res => {
                    if(res.code=='200'){ 
                        this.$message.success(tips+'成功'); 
                        this.getData();
                    }else{ 
                        this.$message.error(tips+'失败');
                    } 
                });
            })
            .catch(() => {}); 
           
        },
 
        
        //详情
        handleDetail(index, row){
            this.form2 = row; 
            if(row.channelType=='1'){
                this.detailVisible = true; 
            }
            
        },
        // 删除
        handDelete(index, row) {  
            this.form.id=row.id; 
            this.form.mid = this.mid;
            this.form.stationId = this.stationId; 
            // 二次确认删除
            this.$confirm('该渠道所有商品将删除，是否要删除？', '提示', {
                type: 'warning'
            }).then(() => {
                handDelete(this.form).then(res => {
                    if(res.code=='200'){ 
                        this.$message.success('删除成功'); 
                        this.$set(this.query, 'pageIndex', 1); 
                        this.getData();
                    }else if(res.code=='201'){
                        //处理该等级绑定的成员
                        this.$message.error("该渠道商品仍有订单未结算，请手动结算订单！"); 
                    }else{
                        this.$message.error("删除失败"); 
                    } 
                });
            }) 
        },
        // 分页导航
        handlePageChange(val) { 
            this.$set(this.query, 'pageIndex', val);
            this.getData();
        },
        //分页数量更改导航
        handleSizeChange(val){
            this.$set(this.query, 'pageSize', val);
            this.getData();
        },
        handlePageChange2(val) { 
            this.$set(this.query2, 'pageIndex', val);
            this.getData2();
        },
        //分页数量更改导航
        handleSizeChange2(val){
            this.$set(this.query2, 'pageSize', val);
            this.getData2();
        }
    }
};
</script>

<style>

.el-upload-list--picture-card .el-upload-list__item{
    width:100px;
    height:100px ;
}
.el-upload--picture-card{
    width:100px ;
    height:100px ;
    line-height:100px ;
}
</style>
<style scoped>
.label{
    background: #eee;
    font-size: 14px;
    height: 32px;
    display: inline-block;
    line-height: 33px;
    width:100px;
    text-align:center;
    color: #555;
  }
  .label-span{
      display: inline-block;
      height: 45px;
  }
.handle-box {
    width:100%;
    margin-bottom: 20px;
    overflow-x:auto;
}

.handle-select {
    width: 100px;
    display: inline-block;
}

.handle-input {
    width: 150px;
    display: inline-block;
}
.handle-del {
    float:right; 
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
    margin-left:0;
}
.mr15 {
    margin-right: 15px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
</style>
